type StorableImageErrorOptions = {
    cause?: unknown;

    // Absent when the request never reached the server.
    status?: number;
};

export default class StorableImageError extends Error {
    status?: number;

    constructor(message?: string, options?: StorableImageErrorOptions) {
        super(message, options);
        this.name = 'StorableImageError';
        this.status = options?.status;
    }
}
